"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Text = require("../../components/Text/Text.util");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var Tab = {
  styles: function styles(theme) {
    return {
      root: _objectSpread(_objectSpread({}, (0, _Text.setTextCssVars)({
        fontSize: theme.typography.fontSize + 2,
        fontWeight: 800,
        color: "".concat(theme.colors.baseContrast100, "BF") // adding 75% opacity
      })), {}, {
        textShadow: ".3px .3px .7px ".concat(theme.colors.baseShadow, "40"),
        "&:hover, &:focus-visible": _objectSpread({
          background: "none"
        }, (0, _Text.setTextCssVars)({
          color: theme.colors.baseContrast100
        })),
        "& svg": {
          fill: "".concat(theme.colors.baseContrast100, "BF"),
          // adding 75% opacity
          width: 17,
          height: 17,
          minHeight: 17,
          minWidth: 17
        },
        "&:hover svg": {
          fill: theme.colors.baseContrast100
        }
      }),
      selected: _objectSpread(_objectSpread({
        border: "none"
      }, (0, _Text.setTextCssVars)({
        fontWeight: 800,
        color: theme.colors.baseContrast100
      })), {}, {
        "& svg": {
          fill: theme.colors.baseContrast100
        },
        "& label": {
          "&:after": {
            content: "''",
            backgroundColor: theme.colors.baseContrast100,
            borderRadius: "0.5px",
            height: "2px",
            width: "24px",
            position: "absolute",
            bottom: theme.spacing.base,
            // eslint-disable-next-line @atg/css-rtl-support
            left: "50%",
            // eslint-disable-next-line @atg/css-rtl-support
            transform: "translateX(-50%)"
          }
        }
      }),
      indicator: {
        border: "none",
        paddingBottom: theme.spacing.base
      }
    };
  }
};
var _default = exports.default = Tab;